import React, { useContext, useState, useMemo, useEffect, useImperativeHandle, forwardRef,useRef } from "react";
import { TableBody, TableRow, TableCell, Menu, MenuItem, } from "@mui/material";
import { ThemeContext } from "../../../../context/ThemeContext";
import { closeOrder, deleteSLTPOrders } from "../../../../api/request/dashboard/dashboard";
import '../../../../App.scss'
import usePendingOrderCell from "../../../tablecells/PendingOrderCell";
import toast from 'react-hot-toast';
import Checkbox from '@mui/material/Checkbox';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { deleteOrdersData } from '../../../../store/Slices/orderPositionSlice'
import { setEditOrderDetail, setTradeModalOpen } from "../../../../store/Slices/globalSymbolSlice";
import { addJournalLog } from "../journal/addJournalLog";
import { getCookies } from "../../../../services/Cookies";
import EditPositionModal from "../../../modal/EditSLTP/EditPositionModal";

const Orders = forwardRef(({ sortConfig, searchQuery, selectedRows, setSelectedRows, setVisibleOrders }, ref) => {
    const { darkMode } = useContext(ThemeContext);
    const accountId = localStorage.getItem('accountID');
    // const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
    const [hoveredRow, setHoveredRow] = useState(null);
    const [hoveredCell, setHoveredCell] = useState(null);
    const { t } = useTranslation()
    const { symbols } = useSelector(state => state.watchlist)
    const orders = useSelector((state) => state.orderPosition.orders, shallowEqual);
    const updateClmData = useSelector(state => state.orderPosition.updateClmData);
    const dispatch = useDispatch()
    const [contextMenu, setContextMenu] = useState(null);
    const [activeRowId, setActiveRowId] = useState(null);
    const username = getCookies('username')
    const componentName = 'Trade'
    const clientId = getCookies("clientId");
    const storageKey = `hiddenColumns_${clientId}_${componentName}`;
    const [editSLTPData, setEditSLTPData] = useState(null);
    const [editModalOpen, setEditModalOpen] = useState(false)
    const handleContextMenu = (event, row) => {
        event.preventDefault();
        setContextMenu({
            mouseX: event.clientX + 2,
            mouseY: event.clientY - 6,
            row,
        });
    };

    useEffect(() => {
      console.log(selectedRows)
    }, [selectedRows])
    

    const handleCloseContextMenu = (event) => {
        setContextMenu(null);
    };
    const handleMouseEnter = (rowIndex, cellIndex) => {
        setHoveredRow(rowIndex);
        setHoveredCell(cellIndex);
    };

    const handleMouseLeave = () => {
        setHoveredRow(null);
        setHoveredCell(null);
    };

    const enrichedOrders = orders.length ? orders?.map(order => {
        const matchingSymbol = Object.values(symbols).find(symbol => Number(symbol.id) === Number(order.symbolId));
        return {
            ...order,
            currentPrice: matchingSymbol?.bid || "N/A"
        };
    }) : [];

    const filteredData = enrichedOrders
    const orderSLTP = useSelector(state => state.orderPosition.orderSLTP);

    // const allSelected = selectedRows.length === combinedData.length && combinedData.length > 0;

    const combinedData = useMemo(() => {
        const sltpOrders = Array.isArray(orderSLTP)
            ? orderSLTP.filter(order => order && order.id && order.symbolId)
            : [];

        const merged = [...filteredData, ...sltpOrders];

        return merged.sort((a, b) => {
            if (!sortConfig.key) return 0;

            const getSortableValue = (row) => {
                switch (sortConfig.key) {
                    case 'openPrice':
                        return row.openPrice ?? row.price ?? 0;
                    case 'type':
                        return row.side ?? row.type ?? 0;
                    default:
                        return row[sortConfig.key] ?? '';
                }
            };

            const valueA = getSortableValue(a);
            const valueB = getSortableValue(b);

            if (typeof valueA === 'number' && typeof valueB === 'number') {
                return sortConfig.direction === 'asc' ? valueA - valueB : valueB - valueA;
            }
            if (typeof valueA === 'string' && typeof valueB === 'string') {
                return sortConfig.direction === 'asc'
                    ? valueA.localeCompare(valueB)
                    : valueB.localeCompare(valueA);
            }

            return 0;
        });
    }, [filteredData, orderSLTP, sortConfig]);

    const handleRowSelect = (rowId) => {
        setSelectedRows((prev) =>
            prev.includes(rowId) ? prev.filter(id => id !== rowId) : [...prev, rowId]
        );
    };

    const handleOrderCloseClick = async (rowId) => {
        if (!rowId) {
            toast.error("No order selected");
            return;
        }

        const selectedRow = combinedData.find(row => row?.id === rowId);
        if (!selectedRow) {
            toast.error("Order not found");
            return;
        }
        console.log(selectedRow);

        try {
            const payload = { accountId: Number(accountId), id: selectedRow.id };
            console.log('payload', payload);

            let closeResponse;

            if (selectedRow.positionId) {
                closeResponse = await deleteSLTPOrders(payload);
            } else {
                closeResponse = await closeOrder(payload);
            }

            const responseMessage = closeResponse?.data?.message || closeResponse?.message || "";

            if (closeResponse.status === 200) {
                dispatch(deleteOrdersData(rowId));
                // toast.success(responseMessage || `Order #${selectedRow.id} has been canceled successfully.`);
            } else {
                const genericStatus = closeResponse?.status;
                if (genericStatus && genericStatus !== 200) {
                    toast.error("Order closure restricted to administrators.");

                } else {
                    addJournalLog('cancelOrderError', `Cancel Order: #${selectedRow.id} failure: ${responseMessage}, Account ${username}: ${accountId}.`);
                    toast.error(responseMessage || `Failed to close order #${selectedRow.id} (${symbols[selectedRow.symbolId]?.name || "Unknown"})`);
                }
            }
        } catch (error) {
            console.error("Error closing order:", error);
            const backendMessage = error?.response?.data?.message || error.message || "Unknown error occurred";
            addJournalLog('cancelOrderError', `Cancel Order: #${selectedRow.id} failure: ${backendMessage}, Account ${username}: ${accountId}.`);
            toast.error(`Order #${rowId} failed: ${backendMessage}`);
        }
    };
    const handleEditSLTP = (row) => {
        const filteredSLTPs = orderSLTP.filter(sltp => sltp.positionId === row.positionId);
        setEditModalOpen(true)
        setEditSLTPData(filteredSLTPs);
        console.log(row);

    };
    const handleCloseModal = () => {
        setEditModalOpen(false);
        setEditSLTPData(null);
    };
    const PendingOrderCell = usePendingOrderCell(handleOrderCloseClick, orderSLTP, handleEditSLTP,handleContextMenu)
    const getInitialVisibleColumns = () => {
        const storedHiddenColumns = JSON.parse(localStorage.getItem(storageKey));
        if (storedHiddenColumns) {
            return PendingOrderCell.reduce((acc, col) => ({
                ...acc,
                [col.dataIndex]: !storedHiddenColumns.includes(col.dataIndex)
            }), {});
        }
        return PendingOrderCell.reduce((acc, col) => ({ ...acc, [col.dataIndex]: true }), {});
    };

    const [visibleColumns, setVisibleColumns] = useState(getInitialVisibleColumns);
    useEffect(() => {
        const storedHiddenColumns = JSON.parse(localStorage.getItem(storageKey)) || [];

        const initialCols = PendingOrderCell.reduce((acc, col) => {
            acc[col.dataIndex] = !storedHiddenColumns.includes(col.dataIndex);
            return acc;
        }, {});
        setVisibleColumns(initialCols);
    }, [updateClmData]);


    useEffect(() => {
        const hiddenCols = Object.keys(visibleColumns).filter((key) => !visibleColumns[key]);
        if (hiddenCols.length > 0) {
            localStorage.setItem(storageKey, JSON.stringify(hiddenCols));
        } else {
            localStorage.removeItem(storageKey);
        }
    }, [updateClmData]);



    const handleEditOrderClick = () => {
        if (contextMenu?.row) {
            dispatch(setEditOrderDetail(contextMenu?.row));
            dispatch(setTradeModalOpen(true));
            handleCloseContextMenu();
        } else {
            toast.error("No order selected.");
            dispatch(setEditOrderDetail(null));

        }
    };
    // Replace the current filteredVisibleOrders calculation and useEffect with:
    const filteredVisibleOrders = useMemo(() => {
        const filtered = combinedData.filter((row) => {
            if (!searchQuery) return true;
            const loweredQuery = searchQuery.toLowerCase();
            return PendingOrderCell.some((col) => {
                const value = row[col.dataIndex];
                return value?.toString().toLowerCase().includes(loweredQuery);
            });
        });
        
        // Create stable references by only including essential data
        return filtered;
    }, [combinedData, searchQuery]);
    
    // Use a ref to track previous values and only update when necessary
    const previousFilteredOrdersRef = useRef([]);
    
    useEffect(() => {
        const hasChanged = (
            filteredVisibleOrders.length !== previousFilteredOrdersRef.current.length ||
            filteredVisibleOrders.some((order, index) => {
                const prev = previousFilteredOrdersRef.current[index];
                return !prev || order.id !== prev.id;
            })
        );
        
        if (hasChanged) {
            setVisibleOrders(filteredVisibleOrders);
            previousFilteredOrdersRef.current = filteredVisibleOrders;
        }
    }, [filteredVisibleOrders]);

    useImperativeHandle(ref, () => ({
        closeOrderById: handleOrderCloseClick,
    }), [handleOrderCloseClick]);
    return (
        <>
            {/* <span>Hello</span> */}
            {combinedData.length === 0 ? (null) : (
                <TableBody>
                    {filteredVisibleOrders.map((row, index) => (
                        <TableRow sx={{ backgroundColor: activeRowId === row.id ? (darkMode ? 'var(--highlightDark)' : 'var(--highlightLight)') : 'inherit', '&:hover': { backgroundColor: darkMode ? '#1f2635' : '#f5f5f5', } }}
                            onClick={(e) => {
                                if (e.target.closest('button') || e.target.closest('input[type="checkbox"]')) return;
                                setActiveRowId(row.id);
                            }} key={row.id} onContextMenu={(event) => {
                                event.preventDefault();
                                handleContextMenu(event, row);
                                setActiveRowId(row.id);
                            }}>
                            <TableCell padding="checkbox" sx={{ border: "none", padding: "5px 5px", }}>
                                <Checkbox checked={selectedRows?.includes(row.id)} onChange={() => handleRowSelect(row.id)} sx={{ width: 24, height: 24, "& .MuiSvgIcon-root": { fontSize: 12 }, }} />
                            </TableCell>

                            {PendingOrderCell.map((col, colIndex) => {
                                const isVisible = visibleColumns[col.dataIndex];
                                if (!isVisible) return null;
                                return (
                                    <TableCell key={col.dataIndex} onMouseEnter={() => handleMouseEnter(index, colIndex)} onMouseLeave={handleMouseLeave} sx={{ fontSize: "0.8rem", border: "none", padding: "5px 5px", position: "relative", overflow: "hidden", }}>
                                        {isVisible && (col.render ? col.render(row[col.dataIndex], row) : row[col.dataIndex])}
                                    </TableCell>
                                );
                            })}
                        </TableRow>
                    ))}
                </TableBody>
            )}
            <Menu sx={{ "& .MuiList-root": { padding: 0 } }} open={contextMenu !== null} onClose={handleCloseContextMenu} anchorReference="anchorPosition" anchorPosition={contextMenu ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined}>
                <div style={{ backgroundColor: darkMode ? "#262f3f" : "" }}>
                    {!contextMenu?.row?.positionId && (<MenuItem sx={{ fontSize: 13.5 }} onClick={handleEditOrderClick}>{t('editOrder')}</MenuItem>)}
                    <MenuItem sx={{ fontSize: 13.5 }} onClick={() => handleOrderCloseClick(contextMenu?.row?.id)}>{t("cancelOrder")}</MenuItem>
                </div>
            </Menu>
            {editModalOpen && (<EditPositionModal open={editModalOpen} handleClose={handleCloseModal} editSLTP={editSLTPData} />)}
        </>
    );
});

export default Orders;